module.exports = __webpack_public_path__ + "static/img/10.9bffb81a.jpg";